
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3><inlineCode parentName="h3">{`ThemeConsumer`}</inlineCode>{` | v4`}</h3>
    <p>{`This is the `}<a parentName="p" {...{
        "href": "https://reactjs.org/docs/context.html#consumer"
      }}>{`"consumer" component`}</a>{` created by `}<inlineCode parentName="p">{`React.createContext`}</inlineCode>{` as the companion component to `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{`. It uses the `}<a parentName="p" {...{
        "href": "https://reactjs.org/docs/render-props.html"
      }}>{`render prop pattern`}</a>{` to allow for dynamic access to the theme during rendering.`}</p>
    <p>{`It passes the current theme (based on a `}<a parentName="p" {...{
        "href": "/docs/api#themeprovider"
      }}><inlineCode parentName="a">{`ThemeProvider`}</inlineCode></a>{` higher in your component tree) as an argument to the child function. From this function, you may return further JSX or nothing.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { ThemeConsumer } from 'styled-components'

export default class MyComponent extends React.Component {
  render() {
    return (
      <ThemeConsumer>
        {theme => <div>The theme color is {theme.color}.</div>}
      </ThemeConsumer>
    )
  }
}
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`All styled components `}<a parentName="p" {...{
          "href": "/docs/advanced#theming"
        }}>{`automatically receive the theme as a prop`}</a>{`, so this is only necessary if you wish to access the theme for other reasons.`}</p>
    </blockquote>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;